import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
export var MessageType;

(function (MessageType) {
  MessageType["START"] = "START";
  MessageType["READY"] = "READY";
  MessageType["CHANGED_TOKEN"] = "CHANGED_TOKEN";
  MessageType["SET_LOCAL_ID"] = "SET_LOCAL_ID";
  MessageType["SET_LAST_APPNAME"] = "SET_LAST_APPNAME";
  MessageType["ERROR"] = "ERROR";
  MessageType["CONFIRMATION"] = "CONFIRMATION";
  MessageType["OAUTH_CALLBACK"] = "OAUTH_CALLBACK";
  MessageType["LOGOUT"] = "LOGOUT";
})(MessageType || (MessageType = {}));

var MessageProvider = /*#__PURE__*/function () {
  function MessageProvider(targetWindow, targetOrigin) {
    var _this = this;

    _classCallCheck(this, MessageProvider);

    this.send = function (message) {
      if (!_this.targetOrigin) {
        throw Error('target origin is not defined');
      }

      _this.targetWindow.postMessage(JSON.stringify(message), _this.targetOrigin);
    };

    this.subscribe = function (callback) {
      var all = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var handleMessage = function handleMessage(event) {
        if (all || event.origin === _this.targetOrigin && event.source === _this.targetWindow) {
          var msg;

          try {
            msg = MessageProvider.parseMessage(event);
          } catch (_a) {
            return;
          }

          if (msg.type === MessageType.CONFIRMATION) {
            return;
          }

          callback(msg, event.origin);

          if (_this.targetOrigin && msg.uuid) {
            _this.send({
              type: MessageType.CONFIRMATION,
              uuid: msg.uuid
            });
          }
        }
      };

      window.addEventListener('message', handleMessage, false);
      return function () {
        return window.removeEventListener('message', handleMessage);
      };
    };

    this.targetWindow = targetWindow;
    this.targetOrigin = targetOrigin;
  }

  _createClass(MessageProvider, [{
    key: "setTargetOrigin",
    value: function setTargetOrigin(targetOrigin) {
      this.targetOrigin = targetOrigin;
    }
  }]);

  return MessageProvider;
}();

export { MessageProvider as default };

MessageProvider.parseMessage = function (event) {
  return typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
};